<div class="carousel__wrapper">
  <div class="carousel__title">
    <h2 class="carousel__title" [attr.data-translate]="'title.' + ((title ? title : type) | cammelCase)">
      {{ 'title.' + ((title ? title : type) | cammelCase) | translate: { placeholder: title ? title : type } }}
    </h2>
    <shared-location-widget-carousels [type]="type" (locationChanged)="onLocationChanged()" />
  </div>
  <a [routerLink]="viewAllUrl" [queryParams]="queryParams" class="carousel__view-all button hyperlink">{{
    'public.slider.viewAll' | translate
  }}</a>
  @if (movies?.length) {
    <button pButton *ngIf="navigationEnabled" class="{{ arrowLeftCssSelector }} carousel__left-arrow carousel__arrow">
      <ush-arrow [template]="arrowTemplate" orientation="left" [attr.date-test]="arrowTemplate"></ush-arrow>
    </button>
    <button pButton *ngIf="navigationEnabled" class="{{ arrowRightCssSelector }} carousel__right-arrow carousel__arrow">
      <ush-arrow [template]="arrowTemplate" orientation="right" [attr.date-test]="arrowTemplate"></ush-arrow>
    </button>
  }

  <!-- content -->
  <div class="carousel__content">
    <ng-content select="left-content"></ng-content>
    <ng-container *ngIf="movies?.length && isBrowser; else placeholderTemplate">
      <swiper-container ushSwiperElement [config]="swiperConfig" init="false">
        <swiper-slide [ngClass]="{ 'swiper-height': setSwiperSlideHeightAuto }" *ngFor="let movie of movies">
          <ush-movie-card
            [movie]="movie"
            [orientation]="orientation"
            [sizes]="responsiveSizes"
            [showReleaseMessage]="showReleaseMessage"
            [loading]="loading"
            [type]="type"
            [showReleaseDate]="type === 'coming-soon' || type === 'watch-at-home-soon'"
          ></ush-movie-card>
        </swiper-slide>
        <div class="swiper-scrollbar"></div>
      </swiper-container>
    </ng-container>
    <div class="error-msg" *ngIf="!movies.length && !loading" [innerHTML]="errorMsg | safe: 'html'"></div>
    <ush-loading-indicator *ngIf="loading" [position]="'absolute'"></ush-loading-indicator>
    <ng-content select="right-content"></ng-content>
  </div>
</div>

<ng-template #placeholderTemplate>
  <ng-container *ngIf="loading">
    <swiper-container ushSwiperElement [config]="swiperConfig" init="false">
      <swiper-slide [ngClass]="{ 'swiper-height': setSwiperSlideHeightAuto }" *ngFor="let movie of [].constructor(6)">
        <ui-movie-card-placeholder [orientation]="orientation"></ui-movie-card-placeholder>
      </swiper-slide>
      <div class="swiper-scrollbar"></div>
    </swiper-container>
  </ng-container>
</ng-template>
